import LabelsContext from "../../lang/LabelsContext";
import { useStyles, lineStyle } from "../../components/private/manuscript/submit/SubmitStyle";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import RateReviewIcon from "@material-ui/icons/RateReview";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import StepConnector from "@material-ui/core/StepConnector";
import { withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import ListIcon from "@material-ui/icons/List";
interface SubmitServiceType {
  steps: any;
  ColorlibConnector: any;
  ColorlibStepIcon: any;
}
interface ColorlibStepIconProps {
  active: boolean;
  completed: boolean;
  icon: number;
}
export default function SubmitService(): SubmitServiceType {
  const { Labels } = LabelsContext();
  const steps = [Labels.GENERAL_INFORMATION, Labels.AUTHOR, Labels.REVIEWERS, Labels.PAPER_FILES, Labels.OVERVIEW];
  const ColorlibConnector = withStyles(lineStyle)(StepConnector);
  function ColorlibStepIcon({ active, completed, icon }: ColorlibStepIconProps) {
    const classes = useStyles();
    const icons = [
      <ListIcon />,
      <GroupAddIcon />,
      <RateReviewIcon />,
      <AddPhotoAlternateIcon />,
      <AssignmentTurnedInIcon />,
    ];
    return (
      <div
        className={clsx(classes.stepperRoot, {
          [classes.stepperActive]: active,
          [classes.stepperCompleted]: completed,
        })}
      >
        {icons[icon - 1]}
      </div>
    );
  }
  return { steps, ColorlibStepIcon, ColorlibConnector };
}
export type { SubmitServiceType };
